module.exports = __webpack_public_path__ + "media/images/mobile/solutions/2-a8f8c8dd94a73350fcdfa0b7b3b15bf1.jpg";